import { reportModalCtaClick } from '../../../bi/bi';
import { Modals } from '../../../types';
import { useModalsAndWindow } from '../../../context/ModalsAndWindowContext';
export const useConsentModalOnClicks = () => {
  const {
    modals
  } = useModalsAndWindow();
  const onAgreeButtonClick = () => {
    reportModalCtaClick({
      ctaName: 'agree',
      modalType: Modals.userConsent
    });
    modals.userConsent.close({
      answer: 'PROCEED'
    });
  };
  const onCloseButtonClick = () => {
    reportModalCtaClick({
      ctaName: 'close',
      modalType: Modals.userConsent
    });
    modals.userConsent.close({
      answer: 'CANCELED'
    });
  };
  return {
    onAgreeButtonClick,
    onCloseButtonClick
  };
};
//# sourceMappingURL=useConsentModalOnClicks.js.map